
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"id-59a"}},[_c('path',{attrs:{"d":"M375 0v1611H0V0h375z"}})]),_c('clipPath',{attrs:{"id":"id-60b"}},[_c('path',{attrs:{"d":"M340 0a3 3 0 013 3v167a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3h337z"}})]),_c('clipPath',{attrs:{"id":"id-61c"}},[_c('path',{attrs:{"d":"M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0z"}})])]),_c('g',{attrs:{"clip-path":"url(#id-59a)","transform":"translate(-32 -376)"}},[_c('g',{attrs:{"clip-path":"url(#id-60b)","transform":"translate(16 360)"}},[_c('g',{attrs:{"clip-path":"url(#id-61c)","transform":"translate(16 16)"}},[_c('path',{attrs:{"fill":"#00CE67","d":"M0 0h40v40H0V0z"}})]),_c('g',{attrs:{"fill":"none","stroke":"#FFF","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M43.197 33.4l-5.515 6.421a.345.345 0 00-.056.374.355.355 0 00.327.205h2.445V46l5.515-6.421a.345.345 0 00.056-.374.355.355 0 00-.317-.205h-2.455v-5.6zM36.898 44.571c-4.171 0-7.27-1.978-8.781-4.881M37.598 26.503a9.117 9.117 0 016.299 4.097M30.6 32.7a2.1 2.1 0 100-4.2 2.1 2.1 0 000 4.2zM30.6 26.4V25M34.798 30.6h1.4M30.6 34.8v1.4M26.4 30.6H25M27.631 27.632l-.989-.989M33.567 27.632l.99-.989M33.567 33.568l.99.99M27.631 33.568l-.989.99"}})])])])])
          )
        }
      }
    